import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

const IconWrapper = styled.div.attrs(props => ({}))`
  background: none;
  border-radius: 1rem;
  border: none;
  cursor: pointer;
  height: 48px;
  transition: .75s all;
  width: 120px;

  ${p => p.absolute && css `
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    bottom: 40px;
  `}

  ${p => p.bounce && css `
    animation: bouncy 1.5s infinite;
  `}

  svg {
    height: 100%;
    width: 100%;
    transition: .75s all;
  }

  &:hover {
    background: #fff;

    ${p => p.bounce && css `
      animation-play-state: paused;
    `}

    svg {
      fill: #000;
    }
  }

  @keyframes bouncy {
    0%   { bottom: 40px; }
    50%  { bottom: 60px; }
    100% { bottom: 40px; }
  }
`

export { IconWrapper }

IconWrapper.propTypes = {
  transparent: PropTypes.bool,
}

IconWrapper.defaultProps = {
  transparent: false
}